module.exports = __webpack_public_path__ + "img/logout.e21fc5bd.svg";